// ciclo-vida-01 — textos da tela "Ciclo de vida da base", dos botões novos do
// Painel 360 e do relatório "Recuperação de Clientes" (tradução à mão, pt → es).
// Plano: docs/superpowers/plans/2026-09-29-recuperacao-clientes-campanha.md (Task 10).
// %{argN} marca trecho dinâmico (contagem, dia, etc.) — mesmo padrão de recuperacao-01.ts.
const catalogo: Record<string, string> = {
    "A recuperação de clientes está desligada nesta rede.": "La recuperación de clientes está desactivada en esta red.",
    "Abrir cadastro da rede": "Abrir registro de la red",
    "A recuperação de clientes está desligada nesta rede. Para criar campanhas, ligue \"Habilitar recuperação de clientes\" no cadastro da rede, aba Configurações.": "La recuperación de clientes está desactivada en esta red. Para crear campañas, active \"Habilitar recuperação de clientes\" en el registro de la red, pestaña Configuraciones.",
    "Quantos clientes estão ativos, em risco de parar ou já inativos — e quem precisa de um empurrão pra voltar.":
      "Cuántos clientes están activos, en riesgo de dejar de cargar o ya inactivos — y quién necesita un empujón para volver.",
    "Dias para entrar em risco": "Días para entrar en riesgo",
    "Dias para ficar inativo": "Días para quedar inactivo",
    "Usar como padrão do Painel 360": "Usar como estándar del Panel 360",
    "\"Dias para ficar inativo\" precisa ser maior que \"Dias para entrar em risco\" (e no máximo 3650).":
      "\"Días para quedar inactivo\" debe ser mayor que \"Días para entrar en riesgo\" (y como máximo 3650).",
    "%{arg1} da base": "%{arg1} de la base",
    "inclui %{arg1} que nunca abasteceram": "incluye %{arg1} que nunca cargaron combustible",
    "Criar regra de recuperação": "Crear regla de recuperación",
    "O card \"Ciclo de vida da base\" do Painel 360 vai passar a usar %{arg1} dias (risco) e %{arg2} dias (inativo) pra toda a rede. Isso não muda os filtros desta tela, só o padrão.":
      "La tarjeta \"Ciclo de vida de la base\" del Panel 360 va a pasar a usar %{arg1} días (riesgo) y %{arg2} días (inactivo) para toda la red. Esto no cambia los filtros de esta pantalla, solo el estándar.",
    "Padrão do Painel 360 atualizado.": "Estándar del Panel 360 actualizado.",
    "Não foi possível salvar o padrão.": "No fue posible guardar el estándar.",
    "Não foi possível calcular o ciclo de vida da base.": "No fue posible calcular el ciclo de vida de la base.",
    "Não foi possível carregar os clientes deste segmento.": "No fue posible cargar los clientes de este segmento.",
    "Não foi possível exportar. Tente de novo.": "No fue posible exportar. Intente de nuevo.",
    "Nenhum cliente neste segmento.": "Ningún cliente en este segmento.",
    "Exportar CSV": "Exportar CSV",
    "Dias sem abastecer": "Días sin cargar combustible",
    "Campanha ativa": "Campaña activa",
    "Nunca abasteceu": "Nunca cargó combustible",
    "Linhas por página:": "Filas por página:",
    "%{arg1}-%{arg2} de %{arg3}": "%{arg1}-%{arg2} de %{arg3}",
    "Total do período": "Total del período",
    "Trazidos pela campanha": "Traídos por la campaña",
    "Taxa de recuperação": "Tasa de recuperación",
};

export default catalogo;
